import { DealLaScSection } from "@/types/dealLaSc.types";
import { TableCreatorTableList } from "@FillInTableContainer/shared/types/tableCreator.types";

interface DealLaScKeyCommentLayout {
  groupTableKey: DealLaScSection;
  tableList: TableCreatorTableList;
}
export const DEAL_LA_SC_KEY_COMMENT_GROUP_TABLE_LAYOUT: DealLaScKeyCommentLayout =
  {
    groupTableKey: "Key Comment",
    tableList: [
      {
        tableKey: null,
        groupShellList: [
          {
            groupShellKey: null,
            shellList: [
              {
                shellKey: "Quote",
              },
              {
                shellKey: "Spokesperson",
              },
            ],
          },
        ],
      },
    ],
  };
